import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import OutlineCancel from 'react-md-icon/dist/OutlineCancel';
import OutlineCheckCircle from 'react-md-icon/dist/OutlineCheckCircle';
import OutlineInfo from 'react-md-icon/dist/OutlineInfo';
import OutlineErrorOutline from 'react-md-icon/dist/OutlineErrorOutline';
import OutlineClose from 'react-md-icon/dist/OutlineClose';

import { hideToaster } from '../../modules/index';

import './Toaster.scss';

/**
 * Toaster Component
 * This component will render in the main application by default.
 * Use the renderLocation prop to specify a different location, eg: 'drawer'.
 */
class Toaster extends Component {
  // Only re-render if the incoming props differ from the current props
  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps);
  }
  hideToaster(renderLocation) {
    // clear the timeout to prevent hideAlert() from firing twice if the user clicks the toaster's dismiss button
    clearTimeout(this.toasterTimeout);
    this.props.hideAlert(renderLocation);
  }
  static renderIcon(type) {
    const iconProps = { fontSize: '1.5rem', lineHeight: 1, flexShrink: 0 };
    switch (type) {
      case 'danger':
        return <OutlineCancel style={iconProps} className={`text-${type}`} />;
      case 'success':
        return <OutlineCheckCircle style={iconProps} className={`text-${type}`} />;
      case 'info':
        return <OutlineInfo style={iconProps} className={`text-${type}`} />;
      case 'warning':
        return <OutlineErrorOutline style={iconProps} className={`text-${type}`} />;
      default:
        return null;
    }
  }
  render() {
    const {
      classNames,
      renderLocation,
    } = this.props;
    const {
      type,
      content,
      labelAlias,
      isDismissible,
      visibilityTimeout,
      visible,
    } = this.props.toaster[renderLocation];
    const defaultClasses = ['toaster', 'body-md', 'border-0', 'd-flex', 'align-items-center', 'mb-0', 'py-3', 'px-4', `bg-${type}-50`, 'rounded-0'];
    const className = [...defaultClasses, ...classNames].join(' ');
    const alertProps = {
      color: type,
      className,
      isOpen: visible,
    };

    if (isDismissible) {
      defaultClasses.push('alert-dismissible');
    }

    if (visibilityTimeout && isDismissible && visible) {
      this.toasterTimeout = setTimeout(this.hideToaster.bind(this, renderLocation), visibilityTimeout);
    }

    let messageContent;
    if (content) {
      messageContent = content;
    } else if (labelAlias) {
      messageContent = <FormattedMessage id={labelAlias} />;
    }
    // Normally we could simply pass a prop of "toggle" to the Alert component which would add the close buttton
    // along with the proper classes. However, we want to override the icon with our own, so we need to include
    // our own button and icon here.
    const closeButton = isDismissible ? (
      <button
        type="button"
        aria-label="Close"
        className="close d-flex"
        onClick={isDismissible ? this.hideToaster.bind(this, renderLocation) : null}
      >
        <OutlineClose style={{ fontSize: '1rem', lineHeight: 1 }} />
      </button>
    ) : null;
    return (
      <Alert
        {...{ ...alertProps }}
        data-cy="toaster"
      >
        <div className="d-flex flex-row align-items-center w-100">
          {Toaster.renderIcon(type)}
          <span className="text-body px-2 w-100">{messageContent}</span>
          {closeButton}
        </div>
      </Alert>
    );
  }
}

Toaster.defaultProps = {
  classNames: [],
  renderLocation: 'app',
  toaster: {
    app: {},
  },
};

Toaster.propTypes = {
  hideAlert: PropTypes.func.isRequired,
  classNames: PropTypes.arrayOf(PropTypes.string),
  renderLocation: PropTypes.string,
  toaster: PropTypes.shape({
    renderLocation: PropTypes.shape({
      type: PropTypes.string,
      labelAlias: PropTypes.string,
      content: PropTypes.node,
      visible: PropTypes.bool.isRequired,
      isDismissible: PropTypes.bool,
      visibilityTimeout: PropTypes.func,
    }),
  }),
};

export default connect(
  state => ({
    toaster: state.appState.toaster,
  }),
  dispatch => ({
    hideAlert: (location) => {
      dispatch(hideToaster(location));
    },
  })
)(Toaster);



// WEBPACK FOOTER //
// ./src/containers/Toaster/Toaster.jsx